const piiFields = [
	'applicant.contact.email',
	'applicant.contact.firstName',
	'applicant.contact.lastName',
	'applicant.contact.phone',
	'applicant.contact.address.street',
	'coApplicant.contact.email',
	'coApplicant.contact.firstName',
	'coApplicant.contact.lastName',
	'coApplicant.contact.phone',
	'coApplicant.contact.address.street',
	'contact.firstName',
	'contact.lastName',
	'contact.phone',
	'phoneNumber',
	'contact.email',
	'contact.address.street'
];
const standardize = (field) =>
	field
		.replace('applicant.', '')
		.replace('contact.', '')
		.replace('address.', '')
		.replace('Number', '')
		.replace('.sep', '');

// SHA256 hashes a string
const shaHash = async (message, crypto) => {
	const msgUint8 = new TextEncoder().encode(message);
	const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};

// goes through an object of key/value pairs and for each key that includes a string in the piiFields
// list it hashes the value
// all other keys are discarded so only the pii is returned in an object of {fields,vals}
const getHashedPii = (parameterMap, crypto) => {
	const fields = [];
	const vals = [];
	const valsTrimmedLowerCase = [];
	Object.entries(parameterMap).forEach(([field, fieldValue]) => {
		if (piiFields.find((piiField) => field.startsWith(piiField))) {
			fields.push(field);
			vals.push(shaHash(fieldValue, crypto));
			valsTrimmedLowerCase.push(
				shaHash(fieldValue.replace(/\s/g, '').toLowerCase(), crypto)
			);
		}
	});
	return {
		fields,
		vals,
		valsTrimmedLowerCase
	};
};

// the reason you have to pass crypto is because node needs crypto library
// and browsers needs to use window.crypto
const hashPii = async (parameterMap, crypto) => {
	const pii = {};
	const piiTrimmedLowerCase = {};
	const { fields, vals, valsTrimmedLowerCase } = getHashedPii(
		parameterMap,
		crypto
	);
	await Promise.all([
		Promise.all(vals).then((resolvedVals) => {
			fields.forEach((field, index) => {
				pii[standardize(field)] = resolvedVals[index];
			});
		}),
		Promise.all(valsTrimmedLowerCase).then((resolvedVals) => {
			fields.forEach((field, index) => {
				piiTrimmedLowerCase[standardize(field)] = resolvedVals[index];
			});
		})
	]);
	return { fields: pii, fieldsTrimmedLowerCase: piiTrimmedLowerCase };
};

export default hashPii;
